<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class="text-capitalize font-weight-bold" color="primary">+ Add</v-btn>
      </template>
      <v-card class="pa-3" color="pop_bg">
        <div class=" tw-flex tw-w-full tw-justify-between tw-items-center">
          <v-card-title class="dark--text text-h6 mt-n2 ms-2">Add Category</v-card-title>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-divider></v-divider>

        <v-card-text>
          <div class="mt-2 tw-flex tw-flex-col tw-gap-4">
            <h3 class=" dark--text text-body-1 font-weight-bold">
              Enter Meal Category Details
            </h3>
            <v-form @submit="createCategory()" v-model="valid" ref="form">
              <div class=" tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4">
                <div class=" tw-flex tw-gap-1 tw-flex-col">
                  <h5 class="mt-4 text-body-2 dark--text mt-sm-0">
                    Category Name
                  </h5>
                  <v-text-field label="Category Name" v-model="nameEn" :rules="[requiredValidator('category name')]" solo dense></v-text-field>
                </div>

                <div class=" tw-flex tw-gap-1 tw-flex-col">
                  <h5 class="text-body-2 dark--text">
                    Category Name (Arabic)
                  </h5>
                  <v-text-field v-model="nameAr" label="Category Name Arabic" :rules="[requiredValidator('category name in arabic')]" solo dense></v-text-field>
                </div>

                <div>
                  <v-checkbox v-model="pcValueNotRequired" label="Hide P/C Value"> </v-checkbox>
                </div>
                <div>
                  <v-checkbox v-model="pcCustomization" label="Custimize P/C (Main Cource)"> </v-checkbox>
                </div>

                <div class=" tw-flex tw-gap-1 tw-flex-col">
                  <h5 class="text-body-2 dark--text">Currently Active</h5>
                  <v-radio-group v-model="active" :mandatory="false" row>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </div>

                <div class=" tw-flex tw-gap-1 tw-flex-col">
                  <h5 class="text-body-2 dark--text">Show Order</h5>
                  <v-text-field :rules="[requiredValidator('order')]" solo dense label="Show Order" type="number" v-model="showOrder" @keypress="isNumber" min="0"></v-text-field>
                </div>

                <div class=" tw-flex tw-gap-1 tw-flex-col">
                  <h5 class="text-body-2 dark--text">Category Type</h5>
                  <v-select
                    :items="categoryTypes"
                    v-model="categoryType"
                    :rules="[requiredValidatorSelect('category type')]"
                    item-text="nameEn"
                    item-value="_id"
                    label="Category Type"
                    dense
                    :loading="loading"
                    solo
                  ></v-select>
                </div>
              </div>

              <div class=" tw-flex tw-w-full tw-justify-end">
                <v-btn :width="$vuetify.breakpoint.smAndUp ? 120 : 90" color="primary" class=" text-capitalize" @click="createCategory()" :loading="btnloading" :disabled="!valid">Save</v-btn>
              </div>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator, requiredValidatorSelect } from "../../core/methods/validations";
// import categoryIcons from "../components/CategoryIcons.vue";
export default {
  components: {
    // categoryIcons,
  },
  apollo: {
    getAllCategoryTypes() {
      return {
        query: require("../api/getAllCategoryTypes.graphql"),
        result({ data }) {
          if (data.getAllCategoryTypes) {
            this.categoryTypes = data.getAllCategoryTypes;
          }
        },
      };
    },
  },
  data() {
    return {
      requiredValidator: requiredValidator,
      requiredValidatorSelect,
      nameEn: "",
      nameAr: "",
      active: true,
      showOrder: "",
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      show_dialog_box: false,
      pcValueNotRequired: false,
      pcCustomization: false,
      selectedIcon: "",
      categoryTypes: [],
      categoryType: null,
    };
  },
  methods: {
    updateIcon(icon) {
      this.selectedIcon = icon;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    createCategory() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("@/menu-packages/api/createCategory.graphql"),
          variables: {
            nameEn: this.nameEn,
            nameAr: this.nameAr,
            showOrder: this.showOrder,
            active: this.active,
            pcValueNotRequired: this.pcValueNotRequired,
            pcCustomization: this.pcCustomization,

            icon: this.selectedIcon,
            categoryType: this.categoryType,
          },
          update: (store, { data: { createCategory } }) => {
            try {
              const query = {
                query: require("@/menu-packages/api/getAllCategories.graphql"),
                variables: {
                  limit: 25,
                  skip: 0,
                },
              };

              let allCategories = store.readQuery(query);
              allCategories.getAllCategories.category.unshift(createCategory); //push to top
              store.writeQuery({
                ...query,
                data: allCategories,
              });
              this.text = "Category Added";
              this.snackbar = true;
              this.show_dialog_box = false;
            } catch (e) {
              // console.log(e);
              console.log("Something bad happend- CategoryForm.vue");
            }
            this.$refs.form.reset();
            this.btnloading = false;
          },
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    close() {
      this.show_dialog_box = false;
    },
  },
};
</script>

<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
